import {MAIN_APP} from '../MidiPlay.jsx';
import UtilDom from '../util/UtilDom.jsx';

const UPDATE_INTERVAL = 10;

export class AudioPlayback {

    interval: null;
    timeouts: null;

    start_profiler(buffer) {
        const time_start = Date.now() + buffer;
        MAIN_APP.setState({time_start: time_start});
        this.interval = setInterval(function () {
            const profile_data = MAIN_APP.state.processors.map((p, key) => {
                return p.get_active_data();
            });
            MAIN_APP.setState({
                profile_data: profile_data,
                cursor_pos: Date.now() - time_start
            });
        }, UPDATE_INTERVAL);
    }

    stop_profiler() {
        clearInterval(this.interval);
    }

    perform_event(event, play_actions, processor_events) {
        play_actions.forEach(action => {
            const processor = MAIN_APP.state.processors[action.processor];
            if (!processor) {
                console.error('processor error during play', action)
            } else {
                processor.play(action);
                setTimeout(function() {
                    const next_note = processor_events[action.processor].shift();
                    processor.pause(next_note);
                }, action.decay_begin);
            }
        });
        MAIN_APP.setState({current_event: event});
    }

    start(events) {

        console.log('time_events', events.time_events);
        console.log('processor_events', events.processor_events);

        // queue the initial data for each processor
        const processor_events = UtilDom.deepCopy(events.processor_events);
        processor_events.forEach((event_list, key) => {
            const processor = MAIN_APP.state.processors[key];
            const data = event_list.shift();
            processor.queue(data);
        });

        const time_events = UtilDom.deepCopy(events.time_events);

        const that = this;
        this.timeouts = [];
        const buffer = 1500;
        this.start_profiler(buffer);
        for (let i = 0; i < time_events.length; i++) {
            if (!time_events[i].actions) {
                continue;
            }
            const play_actions = time_events[i].actions.filter(action => action.type === 9);
            this.timeouts.push(setTimeout(function () {
                that.perform_event(time_events[i], play_actions, processor_events);
            }, time_events[i].timecode + buffer));
        }
    }

    stop() {
        if (this.timeouts) {
            this.timeouts.forEach((t) => clearTimeout(t));
        }
        this.stop_profiler();
    }

}

export default AudioPlayback;
